import * as React from 'react';
import * as classNames from 'classnames';
import { SVG } from '../../Utils/SVG';
const loadingSpinnerSVG = require('../../../icons/loading-spinner.svg');
import './style.css';

export interface LoadingSpinnerProps {
  className?: string;
}

export interface LoadingSpinnerState {
  /* empty */
}

export class LoadingSpinner extends React.Component<
  LoadingSpinnerProps,
  LoadingSpinnerState
> {
  render() {
    const { className } = this.props;

    return (
      <SVG
        className={classNames(className, 'loading-spinner')}
        src={loadingSpinnerSVG}
      />
    );
  }
}

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/app/components/Common/LoadingSpinner/index.tsx